import { css } from '@emotion/css';
import { Color, Display, JustifyContent, ScreenBreakpoint, Spacing } from 'src/styles';

export const container = css`
  background-color: ${Color.Gray1};
  height: 100%;
  @media (max-width: 489px) {
    width: 90%;
    align-self: center;
  }
`;

export const myipoLogo = css`
  ${Spacing.mt96}
  ${Spacing.mxAuto}
  ${Spacing.mb40}
  ${Display.flex}
  width: 200px;
  height: auto;

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: 132px;
    max-width: 100%;
  }
`;

export const cardWrapper = css`
  width: 564px;
  background: ${Color.Gray1};
  box-shadow: 0px 12px 16px rgba(2, 85, 163, 0.15);
  border-radius: 8px;
`;

export const buttonWrapper = css`
  ${Display.flex}
  ${JustifyContent.center}
  ${Spacing.mt32}
  ${Spacing.mb16}
`;
